import List from "./List";
import Create from "./Create";
import Show from "./Show";
// import Edit from "./Edit";

export const VoucherCreate = Create;
export const VoucherList = List;
export const VoucherShow = Show;
// export const KeywordEdit = Edit;
